import { render } from "./WorkBoard.vue?vue&type=template&id=bb5e9828"
import script from "./WorkBoard.vue?vue&type=script&lang=js"
export * from "./WorkBoard.vue?vue&type=script&lang=js"

import "./WorkBoard.vue?vue&type=style&index=0&id=bb5e9828&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__